import React from 'react';
import { Link } from 'react-router-dom';
import { InstagramIcon, MailIcon, MapPinIcon, PhoneIcon, TwitterIcon, YoutubeIcon } from 'lucide-react';
import { Logo } from './Logo';
import { CATEGORIES } from '../data/products';
const SOCIAL = [{
  label: 'Instagram',
  icon: InstagramIcon
}, {
  label: 'YouTube',
  icon: YoutubeIcon
}, {
  label: 'X',
  icon: TwitterIcon
}];
export function Footer() {
  return <footer id="contacto" className="w-full border-t border-white/10 bg-black" data-id="element-593" data-mp="3ug3c3bc12161">
      <div className="mx-auto grid w-full max-w-7xl gap-12 px-5 py-14 sm:grid-cols-2 lg:grid-cols-4 lg:px-8 lg:py-20" data-id="element-594" data-mp="38za4uuqp54h">
        <div className="sm:col-span-2 lg:col-span-1" data-id="element-595" data-mp="3ldkcr17ga6oj">
          <Logo size="md" data-id="element-596" data-mp="3qdf7jfucjgev" />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/50" data-id="element-597" data-mp="3qcnjqr6zqmz5">
            Accesorios fitness diseñados en Uruguay para entrenar fuerte sin
            dolor, sin lesiones y sin incomodidad.
          </p>
          <div className="mt-6 flex gap-2" data-id="element-598" data-mp="2ez1nkm2prl44">
            {SOCIAL.map(({
            label,
            icon: Icon
          }) => <a key={label} href="#" aria-label={label} className="flex h-10 w-10 items-center justify-center border border-white/15 text-white/70 transition-colors hover:border-pink-500 hover:bg-pink-500 hover:text-white" data-id="element-599" data-mp="3labt60db0esh">
                <Icon className="h-4 w-4" data-id="element-600" data-mp="3q726ifxq4wa7" />
              </a>)}
          </div>
        </div>

        <nav aria-label="Categorías" data-id="element-601" data-mp="817b9zwxjeqw">
          <h2 className="font-display text-lg uppercase tracking-[0.2em] text-white" data-id="element-602" data-mp="3474tnw649z9">
            Tienda
          </h2>
          <ul className="mt-5 space-y-3" data-id="element-603" data-mp="ht3ajear5awp">
            {CATEGORIES.map(cat => <li key={cat.id} data-id="element-604" data-mp="cu0icufvez65">
                <Link to={`/productos?cat=${cat.id}`} className="text-sm text-white/50 transition-colors hover:text-pink-400" data-id="element-605" data-mp="cv1ruuh8ndlr">
                  {cat.label}
                </Link>
              </li>)}
          </ul>
        </nav>

        <nav aria-label="Ayuda" data-id="element-606" data-mp="tw5w602sbejk">
          <h2 className="font-display text-lg uppercase tracking-[0.2em] text-white" data-id="element-607" data-mp="twxqz8ok588s">
            Ayuda
          </h2>
          <ul className="mt-5 space-y-3" data-id="element-608" data-mp="yrv4arsve3rh">
            {['Envíos y devoluciones', 'Guía de tallas', 'Preguntas frecuentes', 'Términos y condiciones'].map(item => <li key={item} data-id="element-609" data-mp="1cmdywh2ko2z8">
                <a href="#" className="text-sm text-white/50 transition-colors hover:text-pink-400" data-id="element-610" data-mp="1clcjy1ifqwc8">
                  {item}
                </a>
              </li>)}
          </ul>
        </nav>

        <div data-id="element-611" data-mp="1rj4yorg5rgpd">
          <h2 className="font-display text-lg uppercase tracking-[0.2em] text-white" data-id="element-612" data-mp="1rhtvasqmkays">
            Contacto
          </h2>
          <ul className="mt-5 space-y-4 text-sm text-white/50" data-id="element-613" data-mp="3oczpzct5yl73">
            <li className="flex items-start gap-3" data-id="element-614" data-mp="3t9gfobg0h7ma">
              <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-pink-500" data-id="element-615" data-mp="3tc2wl1oskzh6" />
              <span data-id="element-616" data-mp="2agop9lcwewk4">Bvar. Artigas 1234, Montevideo, Uruguay</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-617" data-mp="25nlr0zx6eyxl">
              <PhoneIcon className="mt-0.5 h-4 w-4 shrink-0 text-pink-500" data-id="element-618" data-mp="21mtik8w4oy2d" />
              <a href="tel:+59899123456" className="hover:text-white" data-id="element-619" data-mp="21kpg7vdvo747">
                +598 99 123 456
              </a>
            </li>
            <li className="flex items-start gap-3" data-id="element-620" data-mp="2tehr0kbsd0fx">
              <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-pink-500" data-id="element-621" data-mp="2td6kicqyhel4" />
              <a href="mailto:hola@zadar.uy" className="hover:text-white" data-id="element-622" data-mp="2pdpglnr6gpi2">
                hola@zadar.uy
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-623" data-mp="2fezx5qjmuwzp">
        <div className="mx-auto flex w-full max-w-7xl flex-col gap-3 px-5 py-6 text-xs text-white/35 sm:flex-row sm:items-center sm:justify-between lg:px-8" data-id="element-624" data-mp="2fgb0xqd2w4qt">
          <p data-id="element-625" data-mp="13y058w176k67">© {new Date().getFullYear()} ZADAR. Todos los derechos reservados.</p>
          <div className="flex items-center gap-5" data-id="element-626" data-mp="2rv7onw1tdw09">
            <Link to="/mis-pedidos" className="transition-colors hover:text-white" data-id="element-627" data-mp="2rtmui7jewf2x">
              Mis pedidos
            </Link>
            <Link to="/login" className="transition-colors hover:text-white" data-id="element-628" data-mp="2ivb6md9xjve6">
              Ingresar
            </Link>
            <Link to="/admin" className="transition-colors hover:text-white" data-id="element-629" data-mp="2ntcq2zb9pwq6">
              Panel admin
            </Link>
            <span className="uppercase tracking-[0.2em]" data-id="element-630" data-mp="3bl1morv4h7cx">Hecho en Uruguay</span>
          </div>
        </div>
      </div>
    </footer>;
}